import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { MatTabsModule } from '@angular/material/tabs';
import { Router, RouterModule } from '@angular/router';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';

import { DialogService } from '@app/shared/services/shared/dialog.service';
import { UiCardComponent } from '@app/shared/ui';
import { UiPageWrapperComponent } from '@app/shared/ui/page-wrapper/ui-page-wrapper.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-project',
  templateUrl: './company-projects-view.component.html',
  imports: [TranslatePipe, MatTabsModule, RouterModule, UiPageWrapperComponent, UiButtonComponent, UiCardComponent]
})
export class CompanyProjectsViewComponent implements OnInit {
  private readonly router: Router = inject(Router);
  private readonly destroyRef: DestroyRef = inject(DestroyRef);
  private readonly dialogService: DialogService = inject(DialogService);

  protected readonly navLinks = [
    {
      label: 'company-projects.project-statuses.active',
      link: './active',
      index: 0
    },
    {
      label: 'company-projects.project-statuses.archived',
      link: './archived',
      index: 1
    },
    {
      label: 'company-projects.project-statuses.draft',
      link: './drafts',
      index: 2
    }
  ];
  protected activeLinkIndex = -1;

  public ngOnInit(): void {
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.activeLinkIndex = this.navLinks.indexOf(this.navLinks.find(tab => tab.link === '.' + this.router.url));
    });
  }

  protected openCreateCompanyProjectDialog(): void {
    this.dialogService.openCreateCompanyProjectDialog();
  }
}
